import { Component, OnInit, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { RequestService } from 'src/app/services/request/request.service';
type Group = 'classification' | 'type' | 'subtype' | 'genre' | 'subgenre';
@Component({
  selector: 'app-sort-prodcuts-options-popover',
  templateUrl: './sort-prodcuts-options-popover.component.html',
  styleUrls: ['./sort-prodcuts-options-popover.component.scss'],
})


export class SortProdcutsOptionsPopoverComponent implements OnInit {
  clasifications: any[] = []; // you said this is already populated

  // Expanded state
  private expandedClass = new Set<string>();
  private expandedGenre = new Set<string>();

  // Selections
  private selected = {
    classification: new Set<string>(),
    type:          new Set<string>(),
    subtype:       new Set<string>(),
    genre:         new Set<string>(),
    subgenre:      new Set<string>(),
  };

  selectedClassifications: string[] = [];
  selectedTypes: string[] = [];
  selectedSubtypes: string[] = [];
  selectedGenres: string[] = [];
  selectedSubgenres: string[] = [];

    @Input() events_eclipse;
    countryCode;
  selectedSortOption: string | null = null;
  selectedSortOption0: string | null = null;
  selectedLanguage: string | null = null;
  priceRange:{upper:number, lower:number};

  
  constructor(private popoverController: PopoverController,      private request: RequestService,) {}




  ngOnInit() {
    if(this.events_eclipse){
                    this.request.createRequestPost('tmFetchEvents',{categories:true }).then((data) =>{
          if (data && typeof data === 'string') {
            try {
              data = JSON.parse(data);
              console.log('getRecordByToken ios:',data);
            } catch (error) {
              console.error("Error parsing data:", error);
            }
            }
          console.log(data);
          this.clasifications=data._embedded.classifications;

 }).catch((error)=>{
      console.log(error);
    });
           // Handle the sort and language logic here
 
    }

  }
  saveSelections() {
    this.popoverController.dismiss({
      sortOption: this.selectedSortOption || 'desc',
  language: this.selectedLanguage || 'es',
  max:this.priceRange?.upper,
  min:this.priceRange?.lower,
  main_sort:this.selectedSortOption0 || 'orders',
  countryCode:this.countryCode
    });
  }


// Keys / trackBy
keyOf(c: any, idx: number): string {
  return c?.primaryId || c?.id || c?.segment?.id || `cls-${idx}`;
}
trackByIdOrName = (_: number, item: any) => item?.id || item?.name || _;

// Data helpers (normalize shapes)
getGenres(c: any): any[] {
  const segGenres = c?.segment?._embedded?.genres;
  const topGenres = c?._embedded?.genres;
  return Array.isArray(segGenres) ? segGenres : (Array.isArray(topGenres) ? topGenres : []);
}
getSubtypes(c: any): any[] {
  const sts = c?.type?._embedded?.subtypes;
  return Array.isArray(sts) ? sts : [];
}
getSubgenres(g: any): any[] {
  const a = g?._embedded?.subgenres;
  const b = g?.subgenres;
  return Array.isArray(a) ? a : (Array.isArray(b) ? b : []);
}

// Expand/collapse classification
isExpanded(c: any, idx: number): boolean {
  return this.expandedClass.has(this.keyOf(c, idx));
}
toggleClass(c: any, idx: number, ev?: Event) {
  ev?.stopPropagation?.();
  const k = this.keyOf(c, idx);
  this.expandedClass.has(k) ? this.expandedClass.delete(k) : this.expandedClass.add(k);
}

// Selection
isSelected(group: Group, id: string): boolean {
  return !!id && this.selected[group].has(id);
}
onToggleSelection(ev: CustomEvent, group: Group, id: string, _payload?: any): void {
  if (!id) return;
  const checked = !!(ev as any)?.detail?.checked;
  const set = this.selected[group];
  checked ? set.add(id) : set.delete(id);
  this.syncArrays();
}
onToggleSubgenre(ev: CustomEvent, s: any, _parentGenreId?: string) {
  const id = s?.id || s?.name;
  this.onToggleSelection(ev as any, 'subgenre', id, s);
}

private syncArrays(): void {
  this.selectedClassifications = Array.from(this.selected.classification);
  this.selectedTypes           = Array.from(this.selected.type);
  this.selectedSubtypes        = Array.from(this.selected.subtype);
  this.selectedGenres          = Array.from(this.selected.genre);
  this.selectedSubgenres       = Array.from(this.selected.subgenre);
}
}